import { EP_ADD_GENERAL_EXPEND, EP_CANCEL_GENERAL_EXPEND, EP_DETAILS_GENERAL_EXPEND, EP_EDIT_GENERAL_EXPEND, EP_GET_GENERAL_EXPENDS } from '../constants/endpointConstants';
import api from './Api';


const addGeneralExpend = async (formData) => {
    const response = await api.post(EP_ADD_GENERAL_EXPEND, formData);
    return response.data;
};
const getGeneralExpendDetails = async (generalExpendId) => {
    const response = await api.get(`${EP_DETAILS_GENERAL_EXPEND}/${generalExpendId}`);
    return response.data;
}
const editGeneralExpend = async (formData) => {
    const response = await api.post(EP_EDIT_GENERAL_EXPEND, formData);
    return response.data;
};
const cancelGeneralExpend = async (generalExpendId) => {
    const response = await api.post(EP_CANCEL_GENERAL_EXPEND, generalExpendId);
    return response.data;
};

const getGeneralExpends = async (formData) => {
    const response = await api.post(EP_GET_GENERAL_EXPENDS, formData);
    return response.data;
};

export {addGeneralExpend, getGeneralExpendDetails, editGeneralExpend, cancelGeneralExpend, getGeneralExpends}